import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { BranchesInternationalRepository } from '../repositories/branches-international.repository';

export class ClearLocationIntUseCase implements UseCase<any, any> {
    constructor(private readonly repository: BranchesInternationalRepository) {}

    execute(): Observable<any> {
        return this.repository.clearLocationInt();
    }
}
